import MarketChartsService from './market';
import CoinChartsService from './coin';

class ChartsService {
  market = new MarketChartsService();
  coin = new CoinChartsService();
}

export default ChartsService;
